import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'primereact/resources/themes/saga-blue/theme.css';  // Saga-blue theme
import 'primereact/resources/primereact.min.css';          // Core PrimeReact styles
import 'primeicons/primeicons.css';                        // PrimeReact icons
import '/node_modules/primeflex/primeflex.css';            // PrimeFlex styles
import './index.css';                                      // Global styles

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);